/**
 * Identifiers shared between the app, the API and the push service worker.
 *
 * The service worker cannot import this file - it runs outside the Angular bundle - so the IndexedDB
 * names below are repeated as literals in assets/config/serviceworker.js. Keep the two in step.
 */

/** Must match HttpHeaderNames.InstallationId on the backend. */
export const INSTALLATION_ID_HEADER = 'X-Installation-Id';

/** localStorage key for this browser profile's installation id, generated once and then kept. */
export const INSTALLATION_ID_KEY = 'wac-installation-id';

/** IndexedDB database holding the binding the service worker checks incoming pushes against. */
export const PUSH_BINDING_DB_NAME = 'wac-push';
export const PUSH_BINDING_STORE_NAME = 'binding';
export const PUSH_BINDING_RECORD_KEY = 'current';
